export default "__VITE_ASSET__DYpXRWh3__"